module.exports = __webpack_public_path__ + "static/decoration-edge-ddaa19765954f848eaff80e929079a65.png";